import { getGlobalSubscriptionState } from '../../analytics/shared';
import { ADD_TO_CART_BUTTON, ONE_CLICK_CHECKOUT_BUTTON } from '../../classnames/design-system';
import { centsAsDecimalFixed, formatCents } from '../../utils/money';

const BUNDLE_PRODUCTS = ['the-beauty-kit', 'the-matcha-kit'];

export default class ButtonHandler {
  constructor(className = ADD_TO_CART_BUTTON) {
    this.className = className;
    this.isBundleProductsPage = BUNDLE_PRODUCTS.some((productName) => window.location.pathname.includes(productName));
  }

  getSubscriptionButtonLabel(subscriptionText, subscriptionPrice, isPriceVisible, pricePrecision) {
    return isPriceVisible
      ? `${subscriptionText} — ${formatCents(subscriptionPrice, pricePrecision)}/mo`
      : subscriptionText;
  }

  getOneTimePurchaseButtonLabel(addToCartText, price, otpDiscountValue, isPriceVisible, pricePrecision) {
    const otpPrice = price - ((price * otpDiscountValue) / 100);

    if (!isPriceVisible || this.isBundleProductsPage) {
      return addToCartText;
    }

    return `${addToCartText} — ${formatCents(otpPrice, pricePrecision)}`;
  }

  handle = (params, node) => {
    if (!params) {
      return;
    }

    const {
      disablePricePrecision,
      otpDiscount,
      price,
      productId,
      subscriptionId,
      subscriptionPrice,
      variantId,
      subscription
    } = params;

    const buttons = node.getElementsByClassName(this.className);
    const oneClickCheckoutButtons = node.getElementsByClassName(ONE_CLICK_CHECKOUT_BUTTON);
    const globalSubscriptionState = getGlobalSubscriptionState();
    const otpDiscountValue = Number.isNaN(otpDiscount) ? 0 : Number(otpDiscount);
    const pricePrecision = JSON.parse(disablePricePrecision) ? 0 : 2;

    [...buttons, ...oneClickCheckoutButtons].forEach((button) => {
      const {
        localSubscriptionState,
        customButtonText,
        priceVisible,
        productId: buttonProductId,
        dynamicLabelDisabled
      } = button.dataset;

      const isDynamicLabelDisabled = JSON.parse(dynamicLabelDisabled);

      const addToCartText = button.classList.contains(ONE_CLICK_CHECKOUT_BUTTON)
        ? 'Buy Now'
        : 'Add to Cart';
      const subscriptionText = button.classList.contains(ONE_CLICK_CHECKOUT_BUTTON)
        ? 'Subscribe Now'
        : 'Subscribe';

      const currentSubscriptionState = subscription || localSubscriptionState || globalSubscriptionState;
      const isPriceVisible = JSON.parse(priceVisible);

      if (!isDynamicLabelDisabled) {
        if (customButtonText) {
          button.innerHTML = customButtonText;
        } else {
          const subscriptionLabel = currentSubscriptionState === 'subscription' && subscriptionPrice
            ? this.getSubscriptionButtonLabel(subscriptionText, subscriptionPrice, isPriceVisible, pricePrecision)
            : null;
          const otpLabel = currentSubscriptionState !== 'subscription'
            ? this.getOneTimePurchaseButtonLabel(addToCartText, price, otpDiscountValue, isPriceVisible, pricePrecision)
            : null;

          button.innerHTML = subscriptionLabel || otpLabel;
        }
      }

      if (buttonProductId && +buttonProductId !== productId) return;

      button.setAttribute('data-variant-id', variantId);
      button.setAttribute('value', centsAsDecimalFixed(
        currentSubscriptionState === 'subscription' ? subscriptionPrice : price
      ));

      if (
        button.classList.contains(ONE_CLICK_CHECKOUT_BUTTON)
        && currentSubscriptionState === 'subscription'
      ) {
        button.dataset.subscriptionId = subscriptionId;
      } else {
        button.removeAttribute('data-subscription-id');
      }
    });
  };
}
